import type { LocationQueryValue } from "vue-router";
import cloneDeep from "lodash-es/cloneDeep";
import { QueryParam } from "~/modules/helpers/composables/useQueryParams/classes/QueryParam";
import { QueryParamsType } from "~/modules/helpers/composables";
import { MagentoFilterManager } from "~/modules/catalog/classes/MagentoFilterManager";

export class QueryParamMagentoFilterManager extends QueryParam<
  MagentoFilterManager,
  string
> {
  type = QueryParamsType.str;

  constructor() {
    super();
    this.default = () => new MagentoFilterManager();
    this.value.value = this.getDefault();
  }

  override parse(
    queryVariable: LocationQueryValue | LocationQueryValue[] | undefined,
  ) {
    this.fromQueryVariable((queryVariable as string) || "");
  }

  override getUnrefValue(): MagentoFilterManager | undefined {
    return new MagentoFilterManager({
      filters: cloneDeep(this.value.value?.filters),
    });
  }

  protected fromQueryVariable(
    val: string | string[],
  ): MagentoFilterManager | undefined {
    this.value.value?.reset();
    val = Array.isArray(val) ? val[0] || "" : val || "";
    this.value.value?.readFromURLParams(new URLSearchParams(val));
    return this.value.value;
  }

  toRaw(): string | undefined {
    return this.value.value?.toURLParams();
  }
}
